import { ModelData } from '@hh.ru/magritte-ui';

import { AdditionalMetro, ModelDataMetro } from 'src/components/Search/Common/Metro/types';

export const filterMetroItems = (query: string, lines?: ModelDataMetro[]): ModelDataMetro[] => {
    const result: Array<ModelDataMetro> = [];

    lines?.forEach((line) => {
        if (line.text.toLowerCase().includes(query.toLowerCase())) {
            result.push(line);
        } else {
            line.items?.forEach((metro) => {
                if (metro.text.toLowerCase().includes(query.toLowerCase())) {
                    result.push(metro);
                }
            });
        }
    });

    return result;
};

export const handleMetroOptionChange = (
    id: string,
    selectedMetro: string[],
    allItems: ModelData<AdditionalMetro>[],
    applyDraftFilter: (values: string[]) => void
) => {
    const lineId = id.split('.')[0];
    const isLineChecked = selectedMetro.includes(lineId);

    if (isLineChecked) {
        const selectedValuesWithoutLine: string[] = [];
        allItems.forEach((metro) => {
            if (metro.id !== lineId && metro.id !== id) {
                selectedValuesWithoutLine.push(metro.id);
            }
        });

        applyDraftFilter(selectedValuesWithoutLine);
    } else {
        const selectedValuesDict: Record<string, number> = {};
        selectedMetro.forEach((selectedMetroId) => (selectedValuesDict[selectedMetroId] = 1));

        if (selectedValuesDict[id]) {
            delete selectedValuesDict[id];
        } else {
            selectedValuesDict[id] = 1;
        }

        if (allItems.every((metro) => !!selectedValuesDict[metro.id])) {
            // Заменяем все выбранные станции на id линии.
            const newSelectedValues = selectedMetro.filter(
                (selectedMetroId) => selectedMetroId.split('.')[0] !== lineId
            );
            newSelectedValues.push(lineId);
            applyDraftFilter(newSelectedValues);
        } else {
            applyDraftFilter(Object.keys(selectedValuesDict));
        }
    }
};
